// See: backend/docs/arvento-telemetry.md §11
// Harita üzerinde tek bir araç telemetri marker'ı.
// Status'a göre renk; hover'da bilgi (adres YERİNE son konum yaşı).
// Hareket halindekiler dolgulu + ışımalı → net öne çıkar.

import React, { useState } from "react";
import DirectionsBus from "@mui/icons-material/DirectionsBus";
import { TELEMETRY_THRESHOLDS } from "@routebot/constants";
import "./VehicleTelemetryMarker.css";

// MOVING vurgulu (canlı yeşil), diğerleri daha sakin.
// (Alarm kırmızısı ile karışmaması için MOVING yeşil bırakıldı; istenirse tek satırla değişir.)
const STATUS_COLORS = {
  MOVING: "#00c853",
  IDLE: "#1e88e5", // (eski) — geriye dönük
  IDLING: "#1e88e5", // Rölantide — kontak açık, hareketsiz (mavi)
  PARKED: "#78909c", // Kontak kapalı — cihaz online (nötr gri-mavi)
  ALARMED: "#e53935",
  OFFLINE: "#9e9e9e",
};

// Dolgulu (öne çıkan) durumlar
const FILLED_STATUSES = new Set(["MOVING", "ALARMED"]);

// Aşırı hız eşiği (§20.3). Bu hızın üstündeki araçlar haritada kırmızı vurgulanır.
const OVERSPEED_KMH = TELEMETRY_THRESHOLDS?.OVERSPEED_THRESHOLD_KMH || 100;
const OVERSPEED_COLOR = "#ff1744";

const VehicleTelemetryMarker = ({ snapshot, onClick, ageLabel }) => {
  const [hover, setHover] = useState(false);

  const status = snapshot?.status || "OFFLINE";
  const speed = Number(snapshot?.speed) || 0;
  const isOverspeed = status !== "OFFLINE" && speed >= OVERSPEED_KMH;
  // Çalışır durumda ve o an servissiz (backend /live'da işaretler) → kırmızı rozet.
  const isServiceless = !!snapshot?.serviceless;
  const color = isOverspeed || isServiceless ? OVERSPEED_COLOR : STATUS_COLORS[status] || STATUS_COLORS.OFFLINE;
  const filled = FILLED_STATUSES.has(status) || isOverspeed || isServiceless;
  const heading = Number(snapshot?.heading) || 0;

  return (
    <div
      className={`vehicle-telemetry-marker vehicle-telemetry-marker--${status.toLowerCase()} ${
        isOverspeed ? "vehicle-telemetry-marker--overspeed" : ""
      } ${isServiceless ? "vehicle-telemetry-marker--serviceless" : ""}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(snapshot);
      }}
    >
      <div
        className={`vehicle-telemetry-marker__icon ${filled ? "vehicle-telemetry-marker__icon--filled" : ""}`}
        style={{
          color: filled ? "#fff" : color,
          background: filled ? color : "#fff",
          borderColor: color,
          transform: heading ? `rotate(${heading}deg)` : undefined,
        }}
      >
        <DirectionsBus />
        {isServiceless && <span className="vehicle-telemetry-marker__serviceless-badge">!</span>}
      </div>
      <div className="vehicle-telemetry-marker__plate" style={{ borderColor: color }}>
        {snapshot?.plate || "—"}
      </div>
      {hover && (
        <div className="vehicle-telemetry-marker__tooltip">
          <div className="vehicle-telemetry-marker__tooltip-plate">{snapshot?.plate || "—"}</div>
          <div>Son konum: {ageLabel || "—"} önce</div>
          <div className={isOverspeed ? "vehicle-telemetry-marker__overspeed-speed" : undefined}>
            {snapshot?.speed ?? 0} km/h{isOverspeed ? " ⚠ Aşırı hız" : ""}
          </div>
          {isServiceless && (
            <div className="vehicle-telemetry-marker__serviceless-note">⚠ Servis dışı kullanım</div>
          )}
          {snapshot?.lastAlarmType ? (
            <div className="vehicle-telemetry-marker__alarm">⚠ {snapshot.lastAlarmType}</div>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default VehicleTelemetryMarker;
